<template>
  <span v-text="text" />
</template>

<script>
export default {
  name: 'CampaignModalIpAreaRegionName',
  props: {
    form: {
      type: Object,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    text() {
      const region = this.form.findIpAreaRegion(this.id)
      return region ? region.name : ''
    },
  },
}
</script>

<style></style>
